export const hasEntries = (object1, object2) => {
  let isEqual = true;

  if (typeof object1 === "object" || typeof object2 === "object") {
    const object1Keys = Object.keys(object1);
    const object2Keys = Object.keys(object2);

    if (object1Keys.length >= object2Keys.length) {
      for (const key in object1) {
        if (object1[key] !== object2[key]) {
          if (typeof object1[key] === "object" && typeof object2[key] === "object") {
            isEqual = hasEntries(object1[key], object2[key]);
          } else {
            isEqual = false;
          }
        }
      }
    } else {
      isEqual = false;
    }
  } else {
    isEqual = false;
  }

  return isEqual;
};
